import React from 'react'
import { Outlet } from 'react-router-dom'
import Container from 'components/common/Container'
import c from './SettingsPage.module.scss'

function SettingsPage() {
  return (
    <main className={c.main}>
      <Container>
        <Outlet />
      </Container>
    </main>
  )
}

export default SettingsPage
